
var customFields = function()
{

    var _this = this;

    var container =  $( '[javascript="shop-custom-fields"]' );

    var groupId = parseInt( container.attr( 'group-id' ) );

    var urls = {};

    /**
     * Confirm To Continue
     * @param callback
     */
    var confirmToContinue = function( callback )
    {
        swal({
            title: "Are you sure?",
            text: "This action cannot be reversed",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: 'btn-danger',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: "No, cancel please!",
            closeOnConfirm: false,
            closeOnCancel: false
        }, callback );
    };

    /**
     * Populate Dropdown
     * @param dropdown
     * @param data
     */
    var populateDropdown = function( dropdown, data )
    {
        dropdown.html('');
        for( var i in data ) {
            $('<option />').val(i).text(data[i]).appendTo( dropdown );
        }
    };

    /**
     * On Rules Changed Handler
     * @param e
     */
    var onRulesChangedHandler = function(e)
    {
        e.preventDefault();
        $.getJSON( urls.GET_ANSWERS.replace( /\[ruleId\]/, $(this).val() ), function( response ) {
            populateDropdown( _this.api.answers, response );
        });
    };

    /**
     * Populate Rules
     */
    var populateRules = function()
    {
        $.getJSON( urls.GET_DEFINED_RULES, function( response ) {
            _this.api.ruleBlock.html( response.view );
        });
    };

    /**
     * Populate Fields
     */
    var populateFields = function()
    {
        $.getJSON( urls.GET_DEFINED_FIELDS, function( response ) {
            _this.api.fieldsBlock.html( response.view );
            sortableFields();
        });
    };

    /**
     * On Add Button Click Handler
     * @param e
     */
    var onAddRuleButtonClickHandler = function(e)
    {
        e.preventDefault();
        $.post( urls.ADD_RULE_TO_GROUP, { ruleId: _this.api.rules.val(), answer: _this.api.answers.val() }, populateRules );
    };

    /**
     * Swap Url Placeholders
     * @param obj
     * @returns {*}
     */
    var swapUrlPlaceholders = function( obj )
    {
        for( var i in obj ) {
            obj[i] = obj[i].replace( /\[groupId\]/, groupId );
        }
        return obj;
    };

    /**
     * Get Urls (routes)
     * @param callback
     */
    var getUrls = function( callback )
    {
        callback = callback || function(){};
        $.getJSON( '/admin/shop/custom-fields/get-ajax-urls', function( response ) {
            urls = swapUrlPlaceholders( response );
            callback();
        });
    };

    /**
     * On Click Remove Rule Handler
     * @param e
     */
    var onClickRemoveRuleHandler = function(e)
    {
        e.preventDefault();
        var button = $(this);
        confirmToContinue( function( confirmed ) {
            if( confirmed ) {
                $.get( button.attr( 'href' ), function() {
                    populateRules();
                });
            }
            swal.close();
        });
    };

    /**
     * On Click Add Custom Field Handler
     * @param e
     */
    var onClickAddCustomFieldHandler = function(e)
    {
        e.preventDefault();
        $.fn.ensphere.veto.modalEdit( this, {
            onVisible : function( modalObj ){
                $.fn.ensphere.veto.refreshModal();
            },
            onComplete : function( response, attributes, modal ){
                populateFields();
                modal.semanticUiModal( 'hide' );
            }
        });
    };

    /**
     * On Change Field Type Handler
     * @param e
     */
    var onChangeFieldTypeHandler = function(e)
    {
        e.preventDefault();
        var select = $(this);
        $.get( urls.GET_ADDITIONAL_FIELDS.replace( /\[fieldTypeId\]/, select.val() ), function( response ) {
            _this.api.additionalPlaceholder().html( response );
            $.fn.ensphere.veto.refreshModal();
        });
    };

    /**
     * On Click Edit Field Handler
     * @param e
     */
    var onClickEditFieldHandler = function(e)
    {
        e.preventDefault();
        $.fn.ensphere.veto.modalEdit( this, {
            onVisible : function( modalObj ){
                $.fn.ensphere.veto.refreshModal();
            },
            onComplete : function( response, attributes, modal ){
                populateFields();
                modal.semanticUiModal( 'hide' );
            }
        });
    };

    /**
     * On Click Delete Field Handler
     * @param e
     */
    var onClickDeleteFieldHandler = function(e)
    {
        e.preventDefault();
        var button = $(this);
        confirmToContinue( function( confirmed ) {
            if( confirmed ) {
                $.get( button.attr( 'href' ), function( response ) {
                    populateFields();
                });
            }
            swal.close();
        });
    };

    /**
     * On Sort End Handler
     */
    var onSortEndHandler = function()
    {
        var data = [];
        $( 'tr', _this.api.fieldsBodyBlock() ).each( function( index ) {
            data.push( $(this).attr( 'data-group-field-id' ) );
        });
        $.post( urls.CUSTOM_FIELDS_REORDER, { sort: data }, function( response ) {
            populateFields();
        });
    };

    /**
     * Sortable Fields
     */
    var sortableFields = function()
    {
        Sortable.create( _this.api.fieldsBodyBlock().get(0), {
            handle: '.handle',
            onUpdate: onSortEndHandler
        });
    };

    /**
     * Bind Events
     */
    var bindEvents = function()
    {
        getUrls( function() {
            _this.api.addRuleButton.on( 'click', onAddRuleButtonClickHandler );
            _this.api.rules.on( 'change', onRulesChangedHandler );
            _this.api.addCustomFieldButton.on( 'click', onClickAddCustomFieldHandler );
            container.on( 'click', '[data-for="delete-group-rule"]', onClickRemoveRuleHandler );
            $(document).on( 'change', '[data-for="field-type"]', onChangeFieldTypeHandler );
            $(document).on( 'click', '[data-for="edit-field"]', onClickEditFieldHandler );
            $(document).on( 'click', '[data-for="delete-field"]', onClickDeleteFieldHandler );
            sortableFields();
        });
    };

    this.api = {

        bindEvents              : bindEvents,
        rules                   : $( '[data-for="rule"]', container ),
        answers                 : $( '[data-for="answer"]', container ),
        addRuleButton           : $( '[data-for="add-rule"]', container ),
        ruleBlock               : $( '[data-for="defined-rules"]', container ),
        fieldsBlock             : $( '[data-for="current-fields"]', container ),
        addCustomFieldButton    : $( '[data-for="add-custom-field"]', container ),
        additionalPlaceholder   : function()
        {
            return $( '[data-for="additional-placeholder"]' )
        },
        fieldsBodyBlock         : function()
        {
            return $( '[data-for="current-fields"] tbody', container );
        },
        instantiable            : function()
        {
            return this.rules.length &&
                this.answers.length &&
                this.addRuleButton.length;
        }

    };

    return this.api;
};


